import styled from 'styled-components';
import { rem } from 'polished';
import { ModalIncompletePxStyled } from '../ModalIncompletePxStyled';

export const ModalIncompletePxStyledDS = styled(ModalIncompletePxStyled)`
    
`;
